import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafaf8]" data-testid="loading-screen">
        <div className="flex items-center gap-3">
          <span className="block w-2 h-2 rounded-full bg-[#d95d39] animate-pulse" />
          <span className="text-sm text-[#5a5a53] font-mono tracking-tight">Loading FinCanvas…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
